<template>
  <b-modal
    ref="jobModal"
    size="xxl"
    centered
    modal-class="job-modal"
    static
    hide-footer
    @hide="onHide()"
  >
    <div
      slot="modal-title"
      class="d-flex align-items-center"
    >
      {{ $t('configuration.modal.job.modalTitle') }}: {{ actionTitle }}
      <b-badge class="d-none ml-3 px-2 system-badge">
        {{ $t('configuration.modal.systemBadge') }}
      </b-badge>
    </div>
    <div>
      <b-row
        style="height: 100%"
        class="p-2"
      >
        <b-col class="content-scroll without-footer association-table mx-2">
          <div class="d-flex mb-1 header-row">
            <div class="d-flex">
              <div class="fixed-column">
                <vt-input
                  ref="filter"
                  v-model="filter"
                  class="form-control-sm"
                  :name="$t('configuration.modal.filterResponsibilities')"
                  :placeholder="$t('configuration.modal.filterResponsibilities')"
                />
              </div>
              <div
                v-for="(laboratory, index) in laboratories"
                :key="index"
                class="check-column d-flex align-items-center"
              >
                <span
                  v-tooltip="laboratory.labName"
                  class="pl-2"
                >{{ laboratory.labName }}</span>
              </div>
            </div>
          </div>
          <div
            v-for="(association, index) in filteredInternalResponsibilities"
            :key="index"
            class="d-flex"
          >
            <div class="d-flex bottom-line">
              <div class="fixed-column">
                <span>{{ association.responsibility.translatedName }}</span>
              </div>
              <div
                v-for="(lab, indexLab) in association.laboratories"
                :key="indexLab"
                class="check-column d-flex align-items-center"
                :class="indexLab"
              >
                <b-form-checkbox
                  v-model="lab.assigned"
                  class="ml-2"
                  @change="jobResponsibilityChanged(lab, association)"
                />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import JobResponsibilityConfigurationServices from '@/api/resources/configuration/peopleManagement/job/JobResponsibilityConfigurationServices'
import ResponsibilityConfigurationServices from '@/api/resources/configuration/peopleManagement/responsibility/ResponsibilityConfigurationServices'
import { cloneDeep, isEmpty } from 'lodash'
import { StoreUtils } from '@/shared/util/store-utils'

export default {
    name: 'JobModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            filter: '',
            internalOriginalResponsibilities: [],
            internalResponsibilities: [],
            internalJob: {}
        }
    },
    computed: {
        filteredInternalResponsibilities() {
            return this.internalOriginalResponsibilities.filter(association => {
                return association.responsibility.translatedName.toLowerCase().includes(this.filter.toLowerCase())
            })
        },
        laboratories() {
            // TODO Debería filtrarse por los permisos del usuario para crear/eliminar JobResponsibilities en cada laboratorio
            const storeLaboratories = [...StoreUtils.laboratories]
            storeLaboratories.unshift({
                labName: this.$tc('global.all'),
                all: true
            })
            return storeLaboratories
        }
    },
    methods: {
        async show(selectedJob) {
            this.filter = ''
            if (selectedJob && !isEmpty(selectedJob)) {
                this.internalJob = cloneDeep(selectedJob)
                await this.setJobResponsibilities(this.internalJob)
            } else {
                this.clearJobResponsibilityData()
            }
            this.$refs.jobModal.show()
            this.$nextTick(() => {
                this.$refs.filter.focus()
            })
        },
        async createJobResponsibility(lab, association) {
            const jobResponsibilityCreateRequest = {
                jobCode: this.internalJob.code,
                laboratoryId: lab.labId,
                responsibilityCode: association.responsibility.code
            }
            const [err, response] = await this.toCall(JobResponsibilityConfigurationServices.createJobResponsibility(jobResponsibilityCreateRequest))
            if (err) {
                lab.assigned = false
                this.showErrorModalGlobal(err.message)
                return err
            }
            lab.assigned = true
            lab.jobResponsibilityId = response.id
        },
        async deleteJobResponsibility(lab) {
            const [err] = await this.toCall(JobResponsibilityConfigurationServices.deleteJobResponsibility(lab.jobResponsibilityId))
            if (err) {
                lab.assigned = true
                this.showErrorModalGlobal(err.message)
                return err
            }
            lab.assigned = false
        },
        clearJobResponsibilityData() {
            this.internalResponsibilities = []
            this.internalOriginalResponsibilities = []
            this.internalJob = {
                id: null,
                code: '',
                translatedName: ''
            }
        },
        async jobResponsibilityChanged(lab, association) {
            let err = null
            let allResponsibilityLabs = []
            if (lab.all) {
                [err, allResponsibilityLabs] = this.allLabsJobResponsibilityChanged(lab, association)
            } else {
                if (lab.assigned) {
                    err = await this.createJobResponsibility(lab, association)
                } else err = await this.deleteJobResponsibility(lab, association)
            }
            if (!err) {
                if (lab.all) {
                    if (lab.assigned) {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.jobResponsibilityCreated', allResponsibilityLabs.length, { jobResponsibilities: allResponsibilityLabs.length }))
                    } else {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.jobResponsibilityDeleted', allResponsibilityLabs.length, { jobResponsibilities: allResponsibilityLabs.length }))
                    }
                } else {
                    if (lab.assigned) {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.jobResponsibilityCreated', 1))
                    } else {
                        this.showToastSuccessGlobal(this.$tc('configuration.toastMessages.jobResponsibilityDeleted', 1))
                    }
                }
            }
        },
        allLabsJobResponsibilityChanged(allLabs, association) {
            this.updateLoading(true)
            const allResponsibilityLabs = association.laboratories.filter(lab => !lab.all && allLabs.assigned !== lab.assigned)
            let err = null
            allResponsibilityLabs.forEach(async lab => {
                if (!lab.assigned) {
                    err = await this.createJobResponsibility(lab, association)
                } else {
                    err = await this.deleteJobResponsibility(lab, association)
                }
            })
            this.updateLoading(false)
            return [err, allResponsibilityLabs]
        },
        async setJobResponsibilities(job) {
            this.updateLoading(true)
            const [err, response] = await this.toCall(Promise.all([
                ResponsibilityConfigurationServices.getResponsibilities(),
                JobResponsibilityConfigurationServices.getJobResponsibilitiesByJobCode(job.code)]))
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobal()
                return
            }
            const responsibilities = response[0]
            const jobResponsibilities = response[1]
            responsibilities.forEach(responsibility => {
                let responsibilityParsed = {
                    responsibility: responsibility,
                    laboratories: this.laboratories.map(lab => {
                        let parsedLab = {}
                        parsedLab.labId = lab.labId
                        parsedLab.assigned = false
                        if (lab.all) parsedLab.all = lab.all
                        return parsedLab
                    })
                }
                this.setResponsibilityLaboratories(responsibilityParsed, jobResponsibilities)
                this.internalResponsibilities.push(responsibilityParsed)
            })
            this.internalOriginalResponsibilities = cloneDeep(this.internalResponsibilities)
        },
        setResponsibilityLaboratories(responsibilityParsed, jobResponsibilities) {
            responsibilityParsed.laboratories.forEach(lab => {
                jobResponsibilities.forEach(jobResponsibility => {
                    if (jobResponsibility.responsibility.id === responsibilityParsed.responsibility.id && lab.labId === jobResponsibility.laboratory.labId) {
                        lab.jobResponsibilityId = jobResponsibility.id
                        lab.assigned = true
                    }
                })
            })
            const labsAssigned = responsibilityParsed.laboratories.filter(lab => lab.assigned).length
            let allLabs = responsibilityParsed.laboratories.find(lab => lab.all)
            if (labsAssigned === this.laboratories.length - 1) {
                allLabs.assigned = true
            }
        },
        onHide() {
            this.clearJobResponsibilityData()
        },
        hide() {
            this.clearJobResponsibilityData()
            this.$refs.jobModal.hide()
        }
    }
}
</script>

<style lang="scss">
    .job-modal .modal-body {
        border-radius: .3rem;
    }
    .job-modal .content-scroll {
        height: calc(100vh - 360px);
        overflow-y: auto;
    }
    @media only screen and (max-width: 1366px) and (min-width: 1360px) {
        .job-modal .content-scroll {
            height: calc(100vh - 160px);
        }
    }
</style>
